import { StatusCodes } from '@/common/contracts'
import { i18n } from '@/common/i18n'

import { ApplicationException } from './application'

export class UnprocessableEntityException extends ApplicationException {
  constructor(props?: Partial<UnprocessableEntityException>) {
    super({
      message: i18n().common.exceptions.unprocessableEntityException,
      ...props,
      name: 'UnprocessableEntityException',
      statusCode: StatusCodes.UNPROCESSABLE_ENTITY
    })
  }
}
